
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/amazon-sale",
      function () {
        return require("private-next-pages/amazon-sale/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/amazon-sale"])
      });
    }
  